module.exports = __webpack_public_path__ + "static/media/user-chart.6474e902.svg";